function eachElements(elementOrElements, callback) {
  if (elementOrElements instanceof Node) {
    return [callback(elementOrElements, 0, [elementOrElements])];
  }
  return Array.from(elementOrElements).map(callback);
}
export {
  eachElements
};
//# sourceMappingURL=utils.js.map
